<template>
  <div
    :class="[tableClass, getClassName, !showSlot ? 'matrix_tableClose' : '']"
  >
    <div :class="getClassName + 'Header'">
      {{ $t(tableName) }}
      <span
        v-if="getShowTableMinimize"
        :class="getClassName + 'HeaderToggle'"
        @click="showSlot = !showSlot"
      >
        <appAwesomeIcon
          v-show="!showSlot"
          icon="chevron_up"
          useClass="fa fa-chevron_up"
        />
        <appAwesomeIcon
          v-show="showSlot"
          icon="chevron_down"
          useClass="fa fa-chevron_down"
        />
      </span>
    </div>
    <component :is="getTransitionUsedElement" name="slide-fade">
      <div v-show="showSlot">
        <slot></slot>
      </div>
    </component>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";
export default {
  props: ["tableName", "tableClass"],
  computed: {
    ...mapState(useWebproductStore, [
      "getShowTableMinimize",
      "getTransitionUsedElement"
    ])
  },
  data() {
    return { showSlot: true };
  }
};
</script>
